module.exports = __webpack_public_path__ + "e20227544ea20a417fcdd42af6cd2ebb.png";